import * as types from 'modules/notifications/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {boolean?} State */
const initialState = false;

const isLoading = () => true;

const isEnding = () => false;

export default createReducer(initialState, {
  [types.FETCH_NOTIFICATIONS_DASHBOARD]: isLoading,
  [types.FETCH_NOTIFICATIONS_DASHBOARD_SUCCESS]: isEnding,
  [types.FETCH_NOTIFICATIONS_DASHBOARD_FAILURE]: isEnding,
});
